var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action } from 'mobx';
import { Store } from 'bernie-plugin-mobx';
import { NOOP_LOGGER } from 'bernie-logger';
import { v4 as uuid } from 'uuid';
export class AnalyticsSearchStore extends Store {
  /* tslint:disable:unnecessary-constructor */
  constructor(state = {}, logger = NOOP_LOGGER) {
    super(state, logger);
    this.apolloLinkSetOnServer = false;
    this.apolloLinkSetInBrowser = false;
    this.searchId = uuid();
    this.data = {
      payload: []
    };
  }
  withNewSearchId(fn) {
    return (...args) => {
      const fnReturnValue = fn(...args);
      this.searchId = uuid();
      return fnReturnValue;
    };
  }
  hydrate(data) {
    Object.assign(this, data);
  }
  addPayload(payloadToPush) {
    this.data.payload.push(payloadToPush);
  }
  publishPayload(analyticsStore) {
    if (this.data.payload.length > 0) {
      analyticsStore.publishClientSidePayload(this.data.payload);
      this.data.payload = [];
    }
  }
}
__decorate([action], AnalyticsSearchStore.prototype, "addPayload", null);
__decorate([action], AnalyticsSearchStore.prototype, "publishPayload", null);